import type { ResourceInactivityIntervalDto } from "../../../../features/Schedule/typings/resource-calendar.types";
import { DateTime } from "luxon";

export type InactivityOverlayEvent = {
  color: string;
  editable: false;
  end: string;
  id: string;
  kind: "blocked" | "inactive";
  message: string | null;
  start: string;
  title: string;
};

type P = {
  language: string;
  timezone: string;
  resourceInactivity:
    | {
        floorInactivity?: ResourceInactivityIntervalDto[];
        locationInactivity?: ResourceInactivityIntervalDto[];
        placeInactivity?: ResourceInactivityIntervalDto[];
        vehicleBlocking?: ResourceInactivityIntervalDto[];
        zoneInactivity?: ResourceInactivityIntervalDto[];
      }
    | null
    | undefined;
};

export function generateInactivitySchedule({
  language,
  timezone,
  resourceInactivity
}: Readonly<P>): InactivityOverlayEvent[] {
  if (!resourceInactivity) {
    return [];
  }

  const titles = {
    blocked: language === "de" ? "Blockiert" : "Blocked",
    inactive: language === "de" ? "Gesperrt" : "Inactive"
  };

  const mapToEvents = (
    intervals: ResourceInactivityIntervalDto[] | undefined,
    kind: "blocked" | "inactive",
    source: string
  ): InactivityOverlayEvent[] =>
    (intervals ?? []).map((interval, index) => ({
      id: `inactivity-${source}-${index}-${interval.start}-${interval.end}`,
      kind,
      title: titles[kind],
      start: DateTime.fromISO(interval.start).setZone(timezone).toISO() || DateTime.now().toISO(),
      end: DateTime.fromISO(interval.end).setZone(timezone).toISO() || DateTime.now().toISO(),
      message: interval.message,
      color: "#9e9e9e",
      editable: false
    }));

  return [
    ...mapToEvents(resourceInactivity.placeInactivity, "inactive", "place"),
    ...mapToEvents(resourceInactivity.zoneInactivity, "inactive", "zone"),
    ...mapToEvents(resourceInactivity.floorInactivity, "inactive", "floor"),
    ...mapToEvents(resourceInactivity.locationInactivity, "inactive", "location"),
    ...mapToEvents(resourceInactivity.vehicleBlocking, "blocked", "vehicle")
  ];
}
